import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_SRC } from "@/constants/site";
import { lenisStore } from "@/lib/scroll";

export const LegalSection = ({ title, children }) => (
    <section>
        <h2 className="font-display font-bold uppercase tracking-wide text-lg text-midnight-900 flex items-center gap-3">
            <span className="h-px w-8 bg-gold" aria-hidden="true" />
            {title}
        </h2>
        <div className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed space-y-3">
            {children}
        </div>
    </section>
);

export const LegalLayout = ({ title, testid, children }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
        lenisStore.current?.scrollTo(0, { immediate: true });
    }, []);

    return (
        <div data-testid={testid} className="min-h-screen bg-[#F7F5F1] text-midnight-900">
            <header className="bg-midnight-900 border-b border-white/10">
                <div className="max-w-4xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
                    <Link to="/" data-testid="legal-logo-link" className="flex items-center gap-3">
                        <img
                            src={LOGO_SRC}
                            alt="Pare Brise Paris"
                            className="w-11 h-11 rounded-full object-cover ring-2 ring-gold/60"
                        />
                        <span className="leading-tight">
                            <span className="block font-display font-bold text-sm tracking-wide text-white">
                                PARE BRISE
                            </span>
                            <span className="block font-display font-bold text-xs tracking-[0.35em] text-gold">
                                PARIS
                            </span>
                        </span>
                    </Link>
                    <Link
                        to="/"
                        data-testid="legal-back-link"
                        className="inline-flex items-center gap-2 text-sm font-medium text-gray-300 transition-colors duration-300 hover:text-gold"
                    >
                        <ArrowLeft size={16} />
                        Retour à l'accueil
                    </Link>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
                <h1 className="font-display font-extrabold uppercase tracking-wide text-3xl sm:text-4xl text-midnight-900">
                    {title}
                </h1>
                <span className="mt-5 block h-px w-24 bg-gradient-to-r from-gold to-transparent" />
                <div className="mt-12 space-y-10">{children}</div>
            </main>

            <footer className="border-t border-black/10 py-8">
                <p className="text-center text-xs text-gray-500">
                    © {new Date().getFullYear()} Pare Brise Paris. Tous droits réservés.
                </p>
            </footer>
        </div>
    );
};
